import Vue from 'vue';
import Router from 'vue-router';
import i18n from '../i18n';
import { routes } from './routes';

Vue.use(Router);


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => {
    const msg = (err && err.message) || '';
    if (
      msg.includes('Navigation aborted') ||
      msg.includes('Navigation cancelled') ||
      msg.includes('NavigationDuplicated')
    ) {
      return err;
    }
    throw err;
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => {
    const msg = (err && err.message) || '';
    if (
      msg.includes('Navigation aborted') ||
      msg.includes('Navigation cancelled') ||
      msg.includes('NavigationDuplicated')
    ) {
      return err;
    }
    throw err;
  });
};

const supportedLanguages = ['en', 'sv', 'fi'];
const publicRoutesWithoutLang = ['/login', '/recover-password', '/reset-password'];

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes
});

router.beforeEach((to, from, next) => {
  const storedLang = localStorage.getItem('lang');
  const fallbackLang = supportedLanguages.includes(storedLang) ? storedLang : 'sv';
  const urlLang = supportedLanguages.includes(to.params.lang) ? to.params.lang : null;

  const simplePath = to.path.replace(/^\/(en|sv|fi)(?=\/|$)/, '');
  const activeLang = urlLang || fallbackLang;

  // public routes
  if (publicRoutesWithoutLang.some(route => simplePath.startsWith(route))) {
    if (!urlLang) return next(`/${activeLang}${simplePath}`);

    if (i18n.locale !== activeLang) {
      i18n.locale = activeLang;
      localStorage.setItem('lang', activeLang);
    }
    return next();
  }


  const pathWithoutLang = to.fullPath.replace(/^\/(en|sv|fi)(?=\/|$)/, '');
  if (!urlLang) return next(`/${activeLang}${pathWithoutLang}`);


  if (i18n.locale !== activeLang) {
    i18n.locale = activeLang;
    localStorage.setItem('lang', activeLang);
  }


  let auth = null;
  try {
    auth = JSON.parse(localStorage.getItem('brandexp') || 'null');
  } catch (e) {
    auth = null;
  }

  const token =
    auth?.user?.token?.token ??
    auth?.token?.token ??
    auth?.token ??
    null;

  if (!token) return next(`/${activeLang}/login`);

  return next();
});

export default router;
